import React from "react";
import { Input, Label } from "reactstrap";

const NotesCard = ({
  placeholder,
  type,
  className,
  height,
  value,
  handleChange,
  bsSize,
}) => {
  return (
    <>
      <Input
        placeholder={placeholder}
        type={type}
        className={className}
        style={{ height: height }}
        value={value}
        onChange={handleChange}
        bsSize={bsSize}
      />
    </>
  );
};

export default NotesCard;
